<template>
    <v-container>
        <v-row>
            <v-col
                    cols="12"
            >
                <h1 class="font-weight-bold display-1 text-center " v-if="lang == 'en' ">Contact</h1>
                <h1 class="font-weight-bold display-1 text-center " v-if="lang == 'es' ">Contacto</h1>
                <h1 class="font-weight-bold display-1 text-center " v-if="lang == 'pt' ">Contato</h1>
                <hr>
                <v-row>
                    <v-col cols="12" md="6">
                        <span v-if="lang == 'en'" v-html="page.en"></span>
                        <span v-if="lang == 'es'" v-html="page.es"></span>
                        <span v-if="lang == 'pt'" v-html="page.pt"></span>
                        <p>
                            Email: <v-btn text href="mailto:info@bestchoicevacation.com<">{{page.email}}</v-btn>
                        </p>
                        <p>
                            Phone: <v-btn text href="mailto:info@bestchoicevacation.com<">{{page.phone}}</v-btn>
                        </p>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card
                                elevation="2"
                                shaped
                                outlined
                        >
                            <v-card-title>
                                <span v-if="lang == 'en' ">Send us a message</span>
                                <span v-if="lang == 'pt' ">Nos envie uma mensagem</span>
                                <span v-if="lang == 'es' ">Mandanos un mensaje</span>
                            </v-card-title>
                            <v-card-text>
                                <v-form
                                        ref="form"
                                        v-model="valid"
                                        lazy-validation
                                >
                                    <v-text-field
                                            v-model="name"
                                            :counter="10"
                                            :rules="nameRules"
                                            label="Name"
                                            required
                                    ></v-text-field>

                                    <v-text-field
                                            v-model="email"
                                            :rules="emailRules"
                                            label="E-mail"
                                            required
                                    ></v-text-field>

                                    <v-textarea
                                            v-model="mensage"
                                            :rules="mensageRules"
                                            outlined
                                            label="Mensage"
                                    ></v-textarea>
                                    <v-alert
                                            v-if="send"
                                            outlined
                                            type="success"
                                            text
                                    >
                                        <span v-if="lang == 'en' ">Send</span>
                                        <span v-if="lang == 'pt' ">Sent</span>
                                        <span v-if="lang == 'es' ">Expedido</span>
                                    </v-alert>
                                    <v-btn
                                            v-else
                                            :loading="loading"
                                            :disabled="!valid"
                                            color="success"
                                            class="mr-4"
                                            @click="validate"
                                    >

                                        <span v-if="lang == 'en' ">Send</span>
                                        <span v-if="lang == 'pt' ">Enviar</span>
                                        <span v-if="lang == 'es' ">Enviar</span>
                                    </v-btn>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        props: {
            lang: { type: String },
            appUrl: { type: String },
            cdnUrl: { type: String },
        },
        metaInfo () {
            return {
                title: 'Best Choice Vacation - Contact',
                meta: [
                    {description: 'Best Choice Vacation - Contact'},
                    {keywords: 'Best Choice Vacation - Contact'}
                ]
            }
        },
        data () {
            return {
                valid: false,
                name: '',
                nameRules: [
                    v => !!v || 'Name is required',
                    v => v.length >= 3 || 'Min 3 characters',
                ],
                mensage:"",
                mensageRules: [
                    v => !!v || 'Field is required',
                    v => v.length >= 10 || 'Field 10 characters',
                ],
                email: '',
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                ],
                send:false,
                loading:false,
                page:{
                    en:"",
                    es:"",
                    pt:"",
                }
            }
        },
        methods:{
            validate () {
                this.loading = true;
                this.$refs.form.validate()
                var arr = {
                    name:this.name,
                    email:this.email,
                    mensage:this.mensage,
                };
                arr = JSON.stringify(arr);

                this.$http.post(this.appUrl+"/store/contact",arr).then(response => {
                    console.log(response.data);
                    this.send = true;
                });
            },
        },
        mounted(){
            this.$http.get(this.appUrl+"/store/contact").then(response =>{
                this.page = response.data;
            });
        },
        filters:{

        }
    }
</script>
